import PropTypes from 'prop-types';
import Posts from '@/domain/Blog/Posts';
import client from '@/api/client';
import { postListingQuery } from '@/api/queries';

export async function getStaticProps() {
  const { data } = await client().query({ query: postListingQuery });

  return {
    props: {
      posts: data?.posts?.nodes || [],
      categories: data?.categories?.nodes || [],
    }
  }
}

const defaultProps = {
  posts: [],
  categories: [],
};

const propTypes = {
  posts: PropTypes.arrayOf(PropTypes.object),
  categories: PropTypes.arrayOf(PropTypes.object),
};

export default function Blog({
  posts,
  categories,
}) {
  return (
    <Posts posts={posts} categories={categories} />
  );
}

Blog.defaultProps = defaultProps;
Blog.propTypes = propTypes;
